import { AddProps, Cart, RemoveProps } from "./type";
let InitType: "shopify" | "local" = "local";
if (window.pageType === "demo") {
  InitType = "local";
}

export class CartObj {
  cart: Cart;
  constructor(type: "shopify" | "local") {
    if (InitType === "local") {
      this.cart = new LocalCart();
    } else {
      if (type === "shopify") {
        this.cart = new ShopifyCart();
      } else {
        this.cart = new LocalCart();
      }
    }
  }
  async getCart() {
    await this.cart.getCart();
  }
  async addToCart(props: AddProps) {
    return await this.cart.addToCart(props);
  }
  async removeCart(props: RemoveProps) {
    return await this.cart.removeCart(props);
  }
}

class LocalCart implements Cart {
  async addToCart(props: AddProps) {
    return new Promise((resolve, reject) => {
      resolve(true);
    });
  }
  removeCart(props: RemoveProps) {
    return new Promise((resolve, reject) => {
      resolve(true);
    });
  }
  getCart(): Promise<any> {
    return Promise.resolve(true);
  }
}

class ShopifyCart implements Cart {
  async addToCart(props: AddProps) {
    const res = await fetch("cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: props.variantId,
            quantity: props.quantity,
          },
        ],
      }),
    }).then((res) => res.json());
    console.log("add to cart");
    return res;
  }

  async removeCart(props: RemoveProps) {
    return await fetch("cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates: props.updates }),
    }).then((res) => res.json());
  }
  async getCart() {
    return await fetch("cart.js").then((res) => res.json());
  }
}
